<template>
  <div>
	  <div class="row">
		  <div class="col-lg-12">
			  <h1 class="page-header">Übersicht der Bestatter</h1>
		  </div>
	  </div>

	  <custom-table edit="/undertakers/{:id}" :criteria="criteria" add="/undertakers/new" :default-sort="defSort" search @print="print" :src-model="$store.getters.models('undertakers')" :cols="cols"></custom-table>
  </div>
</template>

<script>
import CustomTable from 'components/custom-table.vue'
import moment from 'moment'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
  beforeRouteEnter (to, from, next) {
    const route = authCheck('undertakers')
    if (route === null) {
      next()
    } else {
      next(route)
    }
  },

	name: 'app',
	data () {
		return {
		    criteria: [
                {
                    'name': 'Name',
                    'json': 'name'
                }
			],

			cols: [
				{
					'name': 'Name',
					'json': 'name',
					'type': 'text'
				}
			],
			defSort: { col: 'id', order: 'asc' }
		}
	},

	components: {
		'custom-table': CustomTable
	},

	activated () {
		this.$store.dispatch('loadModel', 'undertakers')
		.then(response => {
			//
		})
	},

	methods: {
		print (aModels) {
			aModels[0] = aModels[0].map(aValue => {
				return {text: aValue, style: 'tableHeader', alignment: 'center'}
			})

			let dd = {
				header: {
					columns: [
						{
							text: '',
							alignment: 'center',
							style: 'header'
						},
						{
							text: 'Flächenübersicht',
							alignment: 'center',
							style: 'header'
						},
						{
							text: moment().format('YYYY-MM-DD'),
							alignment: 'right'
							//style: 'header'
						}
					]
				},

				footer (currentPage, pageCount) {
					return {
						text: currentPage + '/' + pageCount,
						alignment: 'center'
					}
				},

				content: [
					{
						table: {
							headerRows: 1,
							widths: ['*', '*', '*', '*', '*'],

							body: aModels
						}
					}
				],
				styles: {
					header: {
						fontSize: 18,
						bold: true,
						margin: [0, 0, 0, 10]
					},
					subheader: {
						fontSize: 16,
						bold: true,
						margin: [0, 10, 0, 5]
					},
					tableExample: {
						margin: [0, 5, 0, 15]
					},
					tableHeader: {
						bold: true,
						fontSize: 13,
						color: 'black'
					}
				}
			}

			pdfMake.createPdf(dd).open()
		},

		googleURL (aURL) {
			return 'https://www.google.de/maps/place/?q="' + aURL + '"'
			//return ['<br>']
		}
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// UndertakerOverview.vue?89dc62ae